import { render, staticRenderFns } from "./AppModal.vue?vue&type=template&id=899a1d26&scoped=true&"
import script from "./AppModal.vue?vue&type=script&lang=ts&"
export * from "./AppModal.vue?vue&type=script&lang=ts&"
import style0 from "./AppModal.vue?vue&type=style&index=0&id=899a1d26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899a1d26",
  null
  
)

export default component.exports